// Contrat de peinture des tableaux (table.module.css) — module PUR : aucune directive, aucun hook, aucun état.
// `Table` le lit pour ses éléments natifs ; DataTable (`@ubm/product-ui`, moteur client) attache les classes de
// `tablePresentation` à ses éléments de grille, pour UNE seule origine de peinture. Ce n'est pas une API de construction :
// une table de présentation se compose avec `Table` & co., jamais en recopiant ces classes sur des <div>.
import styles from "./table.module.css";

/** Classes communes Table/DataTable, par rôle d'élément. */
export const tablePresentation = {
  /** Racine (table ou grille) : typo, encre, fond, filet haut, variables géométriques `--ubm-table-*`. */
  root: styles.root,
  /** Densité compacte, à poser AVEC `root`. */
  compact: styles.compact,
  /** Ligne d'en-tête. */
  headRow: styles.headRow,
  /** Libellé de colonne. */
  headCell: styles.headCell,
  /** Ligne de données (filet, survol). */
  row: styles.row,
  /** Cellule de données (filets verticaux en compact). */
  cell: styles.cell,
  /** Chiffres alignés à droite, chasse fixe. */
  numeric: styles.numeric,
  /** Message d'état vide. */
  empty: styles.empty,
} as const;

/** Classes de structure propres à `Table` (sections natives, légende, conteneur de défilement). Internes au dossier. */
export const tableStructure = {
  header: styles.header,
  body: styles.body,
  footer: styles.footer,
  caption: styles.caption,
  container: styles.container,
} as const;

/** Assemble des classes sans fusion Tailwind (les classes de module ne sont pas des utilitaires). */
export function joinClasses(...parts: Array<string | false | null | undefined>): string | undefined {
  const out = parts.filter(Boolean).join(" ");
  return out === "" ? undefined : out;
}
